var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tabs",
    {
      attrs: { type: "card" },
      model: {
        value: _vm.goodsInfoActiveTab,
        callback: function ($$v) {
          _vm.goodsInfoActiveTab = $$v
        },
        expression: "goodsInfoActiveTab",
      },
    },
    [
      _c(
        "el-tab-pane",
        {
          attrs: {
            label: _vm.$t("BusinessOrderAuditCom.skuTitle"),
            name: "sku",
          },
        },
        [
          _vm.goodsInfoActiveTabHistory.has("sku")
            ? _c("SkuList", {
                attrs: {
                  "order-id": _vm.orderId,
                  "has-btn": _vm.hasBtn,
                  "business-type": _vm.businessType,
                },
                on: { onAction: _vm.onAction },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-tab-pane",
        {
          attrs: {
            label: _vm.$t("BusinessOrderAuditCom.skuItemTitle"),
            name: "skuItem",
          },
        },
        [
          _vm.goodsInfoActiveTabHistory.has("skuItem")
            ? _c("SkuLineList", {
                attrs: {
                  "order-id": _vm.orderId,
                  "has-btn": _vm.hasBtn,
                  "business-type": _vm.businessType,
                },
                on: { onAction: _vm.onAction },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }